import { fetchOrchidAPI } from "utils/api";
import { getErrorDetail } from "components/utility/utils";

export default async function putOrchidProCustomLogo(imageData) {
  const res = await fetchOrchidAPI("/api/users/v1/orchid_pro/custom_logo", {
    method: "PUT",
    body: imageData,
  });

  if (!res.ok) {
    throw new Error(
      `failed to upload custom logo: ${getErrorDetail(await res.text())}`,
    );
  }
  return res;
}
